import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { DialogWrapper } from '../DialogWrapper';
import { useEscKey } from '../../../hooks/useEscKey';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedTicket: any;
  onConfirmDelete: () => Promise<void>;
}

export const DeleteDialog: React.FC<DeleteDialogProps> = ({
  open,
  onClose,
  selectedTicket,
  onConfirmDelete
}) => {
  useEscKey(open, onClose);

  const handleDelete = async () => {
    try {
      await onConfirmDelete();
      onClose();
    } catch (error) {
      console.error('Delete error:', error);
    }
  };

  return (
    <DialogWrapper  open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="error" />
          Talep Silme
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          <strong>#{selectedTicket?.id}</strong> numaralı talebi silmek istediğinizden emin misiniz?
        </Typography>
        {selectedTicket?.subject && (
          <Typography sx={{ mb: 2 }}>
            <strong>Konu:</strong> {selectedTicket.subject}
          </Typography>
        )}
        <Alert severity="warning">
          Bu işlem geri alınamaz! Talep ve tüm mesajları kalıcı olarak silinecektir.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>İptal</Button>
        <Button onClick={handleDelete} variant="contained" color="error">
          Sil
        </Button>
      </DialogActions>
    </DialogWrapper>
  );
};